import styles from "../ContactSelector/ContactSelector.module.scss";

const CustomerListItem = ({ customer, isSelected, onToggle, isRemoveMode = false }) => {
  return (
    <div className={styles.contactItem}>
      <div className={styles.contactCheckbox}>
        {isRemoveMode ? (
          <button
            className={styles.removeButton}
            onClick={() => onToggle(customer.id)}
            type="button"
          >
            ×
          </button>
        ) : (
          <button
            className={`${styles.checkButton} ${isSelected ? styles.selected : ''}`}
            onClick={() => onToggle(customer.id)}
            type="button"
          >
            ✓
          </button>
        )}
      </div>

      <div className={styles.contactInfo}>
        <div className={styles.contactName}>
          {customer.display_name || customer.name}
        </div>
        {customer.mc_number && (
          <div className={styles.customerName}>
            MC# {customer.mc_number}
          </div>
        )}
      </div>

      <div className={styles.activitySection}>
        <div className={styles.rfqStats}>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{customer.rfqs_30d || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerListItem;
